export default __webpack_public_path__ + "static/media/explosion.af63a1c3.mp3";